// Multi-language support for Yorm
// Languages: English, French

export const translations = {
  en: {
    // Common
    common: {
      search: "Search",
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      submit: "Submit",
      back: "Back",
      next: "Next",
      close: "Close",
      confirm: "Confirm",
      yes: "Yes",
      no: "No",
      all: "All",
      none: "None",
      more: "More",
      less: "Less",
      error: "Error",
      success: "Success",
      warning: "Warning",
      info: "Info"
    },
    // Navigation
    nav: {
      home: "Home",
      dashboard: "Dashboard",
      bookings: "Bookings",
      messages: "Messages",
      profile: "Profile",
      settings: "Settings",
      support: "Support",
      logout: "Log Out",
      login: "Log In",
      register: "Sign Up",
      analytics: "Analytics",
      promotions: "Promotions",
      favorites: "Favorites"
    },
    // Landing Page
    landing: {
      hero_title: "Find Local Professionals",
      hero_subtitle: "Connect with skilled professionals near you",
      search_placeholder: "What service do you need?",
      location_placeholder: "Location",
      find_artisans: "Find Professionals",
      browse_categories: "Browse Categories",
      more_categories: "More Categories",
      show_less: "Show Less",
      how_it_works: "How It Works",
      step1_title: "Search",
      step1_desc: "Find the service you need",
      step2_title: "Book",
      step2_desc: "Schedule an appointment",
      step3_title: "Done",
      step3_desc: "Get the job done"
    },
    // Auth
    auth: {
      email: "Email",
      password: "Password",
      confirm_password: "Confirm Password",
      full_name: "Full Name",
      phone: "Phone Number",
      login_title: "Welcome Back",
      login_subtitle: "Sign in to continue",
      register_title: "Create Account",
      register_subtitle: "Join our community",
      forgot_password: "Forgot Password?",
      no_account: "Don't have an account?",
      have_account: "Already have an account?",
      customer: "Customer",
      artisan: "Professional",
      select_role: "I am a",
      login_as_customer: "Login as Customer",
      login_as_artisan: "Login as Professional"
    },
    // Customer
    customer: {
      my_bookings: "My Bookings",
      book_now: "Book Now",
      view_profile: "View Profile",
      add_favorite: "Add to Favorites",
      remove_favorite: "Remove from Favorites",
      search_results: "Search Results",
      no_artisans_found: "No professionals found",
      filter_by: "Filter by",
      sort_by: "Sort by",
      rating: "Rating",
      distance: "Distance",
      price: "Price"
    },
    // Artisan
    artisan: {
      my_services: "My Services",
      availability: "Availability",
      online: "Online",
      offline: "Offline",
      accept_booking: "Accept",
      decline_booking: "Decline",
      complete_job: "Complete Job",
      pending_jobs: "Pending Jobs",
      active_jobs: "Active Jobs",
      completed_jobs: "Completed Jobs",
      earnings: "Earnings",
      total_earnings: "Total Earnings"
    },
    // Booking
    booking: {
      status: "Status",
      pending: "Pending",
      accepted: "Accepted",
      completed: "Completed",
      declined: "Declined",
      cancelled: "Cancelled",
      date: "Date",
      time: "Time",
      description: "Description",
      no_bookings: "No bookings found"
    },
    // Chat
    chat: {
      type_message: "Type a message...",
      send: "Send",
      no_messages: "No messages yet",
      chat_locked: "Chat is locked for completed jobs"
    },
    // Support
    support: {
      title: "Customer Support",
      subtitle: "How can we help you?",
      send_message: "Send Message",
      placeholder: "Describe your issue..."
    },
    // Settings
    settings: {
      account: "Account Settings",
      notifications: "Notifications",
      language: "Language",
      theme: "Theme",
      privacy: "Privacy",
      help: "Help & Support"
    },
    // Footer
    footer: {
      about: "About Us",
      faq: "FAQ",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      contact: "Contact Us"
    }
  },

  fr: {
    common: {
      search: "Rechercher",
      loading: "Chargement...",
      save: "Sauvegarder",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      view: "Voir",
      submit: "Soumettre",
      back: "Retour",
      next: "Suivant",
      close: "Fermer",
      confirm: "Confirmer",
      yes: "Oui",
      no: "Non",
      all: "Tout",
      none: "Aucun",
      more: "Plus",
      less: "Moins",
      error: "Erreur",
      success: "Succès",
      warning: "Avertissement",
      info: "Info"
    },
    nav: {
      home: "Accueil",
      dashboard: "Tableau de bord",
      bookings: "Réservations",
      messages: "Messages",
      profile: "Profil",
      settings: "Paramètres",
      support: "Support",
      logout: "Déconnexion",
      login: "Connexion",
      register: "S'inscrire",
      analytics: "Analytique",
      promotions: "Promotions",
      favorites: "Favoris"
    },
    landing: {
      hero_title: "Trouvez des Professionnels Locaux",
      hero_subtitle: "Connectez-vous avec des professionnels qualifiés près de chez vous",
      search_placeholder: "De quel service avez-vous besoin?",
      location_placeholder: "Lieu",
      find_artisans: "Trouver des Professionnels",
      browse_categories: "Parcourir les Catégories",
      more_categories: "Plus de Catégories",
      show_less: "Voir Moins",
      how_it_works: "Comment ça Marche",
      step1_title: "Rechercher",
      step1_desc: "Trouvez le service dont vous avez besoin",
      step2_title: "Réserver",
      step2_desc: "Planifiez un rendez-vous",
      step3_title: "Terminé",
      step3_desc: "Le travail est fait"
    },
    auth: {
      email: "Email",
      password: "Mot de passe",
      confirm_password: "Confirmer le mot de passe",
      full_name: "Nom complet",
      phone: "Numéro de téléphone",
      login_title: "Bon Retour",
      login_subtitle: "Connectez-vous pour continuer",
      register_title: "Créer un Compte",
      register_subtitle: "Rejoignez notre communauté",
      forgot_password: "Mot de passe oublié?",
      no_account: "Pas de compte?",
      have_account: "Déjà un compte?",
      customer: "Client",
      artisan: "Professionnel",
      select_role: "Je suis un",
      login_as_customer: "Connexion Client",
      login_as_artisan: "Connexion Professionnel"
    },
    customer: {
      my_bookings: "Mes Réservations",
      book_now: "Réserver",
      view_profile: "Voir le Profil",
      add_favorite: "Ajouter aux Favoris",
      remove_favorite: "Retirer des Favoris",
      search_results: "Résultats de Recherche",
      no_artisans_found: "Aucun professionnel trouvé",
      filter_by: "Filtrer par",
      sort_by: "Trier par",
      rating: "Note",
      distance: "Distance",
      price: "Prix"
    },
    artisan: {
      my_services: "Mes Services",
      availability: "Disponibilité",
      online: "En ligne",
      offline: "Hors ligne",
      accept_booking: "Accepter",
      decline_booking: "Refuser",
      complete_job: "Terminer",
      pending_jobs: "En attente",
      active_jobs: "Actifs",
      completed_jobs: "Terminés",
      earnings: "Revenus",
      total_earnings: "Revenus Totaux"
    },
    booking: {
      status: "Statut",
      pending: "En attente",
      accepted: "Accepté",
      completed: "Terminé",
      declined: "Refusé",
      cancelled: "Annulé",
      date: "Date",
      time: "Heure",
      description: "Description",
      no_bookings: "Aucune réservation"
    },
    chat: {
      type_message: "Écrivez un message...",
      send: "Envoyer",
      no_messages: "Pas encore de messages",
      chat_locked: "Chat verrouillé pour les travaux terminés"
    },
    support: {
      title: "Service Client",
      subtitle: "Comment pouvons-nous vous aider?",
      send_message: "Envoyer",
      placeholder: "Décrivez votre problème..."
    },
    settings: {
      account: "Paramètres du Compte",
      notifications: "Notifications",
      language: "Langue",
      theme: "Thème",
      privacy: "Confidentialité",
      help: "Aide & Support"
    },
    footer: {
      about: "À Propos",
      faq: "FAQ",
      privacy: "Confidentialité",
      terms: "Conditions",
      contact: "Contact"
    }
  }
};

export const languages = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "fr", name: "Français", flag: "🇫🇷" }
];

export const getDefaultLanguage = () => {
  const saved = localStorage.getItem("yorm_language");
  if (saved && translations[saved]) return saved;
  
  const browserLang = navigator.language.split("-")[0];
  if (translations[browserLang]) return browserLang;
  
  return "en";
};

export const setLanguage = (code) => {
  localStorage.setItem("yorm_language", code);
};

export const t = (path, lang = getDefaultLanguage()) => {
  const keys = path.split(".");
  let value = translations[lang];
  
  for (const key of keys) {
    if (value && typeof value === "object" && key in value) {
      value = value[key];
    } else {
      // Fallback to English if key not found
      value = translations.en;
      for (const fallbackKey of keys) {
        if (value && typeof value === "object" && fallbackKey in value) {
          value = value[fallbackKey];
        } else {
          return path; // Return path if not found
        }
      }
      break;
    }
  }
  
  return typeof value === "string" ? value : path;
};

export default { translations, languages, getDefaultLanguage, setLanguage, t };
